<template>
  <div class="product-comparator" id="productcomparator" >
    <div class="product-comparator__options">
      <div class="product-comparator__type">
        <v-select label="label" :options="options" v-if="options.length > 1"  :placeholder="firstPlaceholder" v-model="selectedOption"></v-select>
      </div>
      <div class="product-comparator__results" v-if="!hidesecondfilter && additionalOptions.length > 1">
        <v-select :options="additionalOptions" class="white" placeholder="Filter by options" v-model="selectedAdditionalOption"></v-select>
      </div>
    </div>

    <div class="product-comparator__items">
      <div v-if="false && currentTaxonomy && currentTaxonomy.acf && currentTaxonomy.acf.upsell_image" class="product-comparator__item product-comparator__item--upsell"
           :style="`background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${currentTaxonomy.acf.upsell_image.sizes.medium_large}) no-repeat center center / cover;`"
           >
          <a class="product-comparator__item product-comparator__item--upsell-link" 
            :href="currentTaxonomy.acf.upsell_link.url">
            <h3 class="product-comparator__item--upsell-title" 
                v-html="currentTaxonomy.acf.upsell_title" ></h3>

            <p class="product-comparator__item--upsell-text">
              {{ currentTaxonomy.acf.upsell_text }}
            </p>
          </a>
      </div>

      <div class="product-comparator__item" v-for="(item, index) in allData" :key="index">
        <a :href="item.link">
          <div class="product-comparator__item--image" v-if="item.featured_image"
            :style="`background:url(${item.featured_image}) no-repeat center center / contain;`"
          ></div>
        
          <h3 class="product-comparator__item--title" v-html="item.title.rendered" ></h3>
        </a>
        <p v-html="item.acf.excerpt || shorten(item.content.rendered, 80)"></p>

        <div class="product-comparator__item--price" v-if="item.acf.price">
          £{{ item.acf.price }} p/m
        </div>
        
        <p>
          <a :href="item.link" class="elementor-button-link elementor-button elementor-size-sm button-white product-comparator__item--seemore">see more</a>
          <a v-if="comparable"  href="#" 
            @click.prevent="select(item)"
            :class="`elementor-button-link 
                   elementor-button 
                   elementor-size-sm 
                   product-comparator__item--comparebutton` + (isSelected(item) ? ' product-comparator__item--active' : '')">
            {{ isSelected(item) ? 'remove from comparison' : 'add to comparison' }}
          </a>
        </p>

        
      </div>
    </div>
    
    <div class="product-comparator__comparisonwrapper" v-if="selectedItems.length > 0">
      <table>
        <thead>
            <td>
            <td v-for="(item, index) in selectedItems" :key="index">
              <h4 class="product-comparator__comparisontitle">{{item.title.rendered}}</h4>
              <div class="product-comparator__comparisonimage"
                   :style="`background:url(${item.acf.main_image.sizes.medium_large}) no-repeat center center / contain;`"
              ></div>
            </td>
        </thead>
        <tbody>
          <tr>
            <td>Popularity</td>
            <td v-for="(item, index) in selectedItems" :key="index">{{ item.acf.popularity }}</td>
          </tr>
          <tr>
            <td>Range</td>
            <td v-for="(item, index) in selectedItems" :key="index">{{ item.acf.range }}</td>
          </tr>
          <tr>
            <td>Regular or Decaf</td>
            <td v-for="(item, index) in selectedItems" :key="index">{{ item.acf.regular_or_decaf }}</td>
          </tr>
          <tr>
            <td>Roast</td>
            <td v-for="(item, index) in selectedItems" :key="index">{{ item.acf.roast }}</td>
          </tr>
          <tr>
            <td>Certifications</td>
            <td v-for="(item, index) in selectedItems" :key="index">
              <ul>
                <li v-for="(certif, indexCertif) in item.acf.certification" :key="indexCertif">{{certif}}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Available as</td>
            <td v-for="(item, index) in selectedItems" :key="index">
              <ul>
                <li v-for="(av, indexAv) in item.acf.availability" :key="indexAv">{{av}}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Origin</td>
            <td v-for="(item, index) in selectedItems" :key="index">{{ item.acf.origin }}</td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
</template>


<script>
  import axios from 'axios';
  export default {
    data: function () {
      return {
        options: [],
        sortOptions: ['Price Lo - Hi', 'Price Hi - Lo', 'Popularity'],
        additionalOptions: [],
        allData: [],
        taxonomyOptions: [],
        filterTaxonomyOptions: [],
        currentTaxonomy: {},
        postId: 0,
        firstPlaceholder: "Filter by brand",
        selectedOption: { label: "Type", code: 0},
        selectedSortOption: "",
        selectedAdditionalOption: {},
        filterTitle: "",
        selectedItems: []
      };
    },
    watch: {
      selectedOption: {
        handler: async function() {

          await this.reloadFromFilter();
          
        }
      },
      selectedAdditionalOption: {
        handler: async function() {
          
          await this.reloadFromFilter();
          
        }
      }
    },
    props: ['wpid', 
            'type', 
            'posttype', 
            'taxonomy', 
            'filtername', 
            'filtertaxonomy', 
            'comparable', 
            'brand', 
            'hidesecondfilter',
            'nodefault',
            'optionstype'],
    methods: {
      async reloadFromFilter() {
          if(this.selectedOption == null) {
            this.selectedOption = null; // { label: "Type", code: 0};
          }

          if (this.optionstype != "machine" && 
                  (!this.selectedOption ||
                   (this.selectedOption && this.selectedOption.code == 0))) {
            await this.getFullData();
          } else {
            await this.getDataByTaxonomy(this.selectedOption ? this.selectedOption.code : 0);
          }
      },
      async sample() {
        const { data } = await axios.get(``);
      },

      select(item) {
        let index = this.selectedItems.indexOf(item)
        if( index >= 0) {
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(item);
        }
      },
      isSelected(item) {
        return this.selectedItems.indexOf(item) >= 0;
      },
      async getFullData() {

        this.selectedItems = [];


        let address = `/wp-json/wp/v2/${this.posttype}?`;
        if(this.filtertaxonomy) {
          address = `/wp-json/wp/v2/${this.posttype}?${this.taxonomy}=${this.currentTaxonomy.id}`;
          
        }
        if(this.brand) {
            address += `&coffee_brands=${this.brand}`;
        }
        address += '&per_page=100';
        
        const { data } = await axios.get(address);

        this.allData = this.sortData(data);

        await this.ensureOptions();

      },
      async getTaxonomyData() {
        if(this.filtertaxonomy) {
          var { data } = await axios.get(`/wp-json/wp/v2/${this.filtertaxonomy}`);
          this.filterTaxonomyOptions = data;
        }

        if(this.taxonomy) {
          var { data } = await axios.get(`/wp-json/wp/v2/${this.taxonomy}`);
          this.taxonomyOptions = data;
        }

        if(this.filtertaxonomy) {
          var { data } = await axios.get(`/wp-json/wp/v2/${this.filtertaxonomy}`);
        } 

        this.filterTaxonomyOptions = data;

      },
      async getDataByTaxonomy(taxonomy) {
        this.selectedItems = [];

        let address = `/wp-json/wp/v2/${this.posttype}?${this.taxonomy}=${taxonomy}`;

        if(this.filtertaxonomy) {
          address = `/wp-json/wp/v2/${this.posttype}?${this.taxonomy}=${this.currentTaxonomy.id}&${this.filtertaxonomy}=${taxonomy}`;
        }

        if(this.optionstype == "machine") {

          address = `/wp-json/wp/v2/${this.posttype}?machine_type=${this.brand}`;

          if (this.selectedOption && this.selectedOption.code > 0) {
            address += `&machine_brand=${this.selectedOption.code}`;
          } 
        }

        if (this.selectedAdditionalOption && this.selectedAdditionalOption.code) {
          address += `&machine_option=${this.selectedAdditionalOption.code}`;
        }

        
        if(this.brand && this.optionstype != "machine") {
          address += `&coffee_brands=${this.brand}`;
        } 

        address += '&per_page=100';

        const { data } = await axios.get(address);

        this.allData = this.sortData(data);
        await this.ensureOptions();

      },
      sortData(data) {
        switch (this.selectedSortOption) {
          case "Popularity": 
            return data.sort((a, b) => {
              let pop1 = a.acf.popularity;
              let pop2 = b.acf.popularity;
              return (pop2 !== undefined ? pop2 : 0) - (pop1 !== undefined ? pop1 : 0);
              });
          break;
          case "Price Hi - Lo": 
            return data.sort((a, b) => {
              let price1 = a.acf.price;
              let price2 = b.acf.price;
              return (price2 !== undefined ? price2 : 0) - (price1 !== undefined ? price1 : 0);
              });
          break;
          case "Price Lo - Hi": 
            return data.sort((a, b) => {
              let price1 = a.acf.price;
              let price2 = b.acf.price;
              return (price1 !== undefined ? price1 : 0) - (price2 !== undefined ? price2 : 0);
              });
          break;
          default:
            console.log("sorting...");
            return data.sort((a, b) => {
              if (a.title.rendered < b.title.rendered) {
                return -1;
              }
              if (a.title.rendered > b.title.rendered) {
                return 1;
              }
              return 0
              
              });
          break;
        }
      },
      shorten(html) {
        var div = document.createElement("div");
        div.innerHTML = html;
        var text = div.textContent || div.innerText || "";

        return text.length > 160 ? `${text.substring(0, 160)}...` : text;
      },
      async ensureOptions() {
        if(this.options.length == 0) {
          this.options.push({label: 'All', code: 0});
          
          for(var i = 0; i < this.allData.length; i++) {
            if(this.allData[i].machine_brand.length > 0) {
              for (var j = 0; j <= this.allData[i].machine_brand.length; j++) {
                let brandId = this.allData[i].machine_brand[j];
                
                if (brandId == undefined || this.options.filter(x => x.code == brandId).length > 0 ) {
                  continue;
                }
                var { data } = await axios.get(`/wp-json/wp/v2/machine_brand/${brandId}`);

                this.options.push({label: data.name, code: data.id})
              }
            }
          }
        }

        if(this.additionalOptions.length == 0) {
          this.additionalOptions.push({label: 'All', code: 0});
          
          for(var i = 0; i < this.allData.length; i++) {
            if(this.allData[i].machine_option && this.allData[i].machine_option.length > 0) {
              for (var j = 0; j <= this.allData[i].machine_option.length; j++) {
                let optionId = this.allData[i].machine_option[j];
                
                if (optionId == undefined || this.additionalOptions.filter(x => x.code == optionId).length > 0 ) {
                  continue;
                }
                var { data } = await axios.get(`/wp-json/wp/v2/machine_option/${optionId}`);

                this.additionalOptions.push({label: data.name, code: data.id})
              }
            }
          }
          this.selectedAdditionalOption = null;
        }
      }
    },
    computed: {
    },
    async mounted() {
      this.postId = this.wpid;
      this.filterTitle = this.filtername;
      
      await this.getTaxonomyData();

      this.currentTaxonomy = this.taxonomyOptions.filter(x => x.link.indexOf(window.location.pathname) > 0)[0];
      if(!this.currentTaxonomy) {
        this.currentTaxonomy = this.filterTaxonomyOptions.filter(x => x.link.indexOf(window.location.pathname) > 0)[0];
      }

      if(this.optionstype != "machine") {
        this.firstPlaceholder = "Filter by type";
      }
      

      if (this.optionstype != "machine" && 
          !this.filtertaxonomy && 
          !this.nodefault &&
          this.currentTaxonomy) {
        this.selectedOption = {label: this.currentTaxonomy.name, code: this.currentTaxonomy.id};
      } else {
        
        this.selectedOption = null;
      }

      // await this.getFullData();

      let options = [];

      if(this.optionstype != "machine") {
        options.push({label: 'All', code: 0});
        for(var i = 0; i < this.filterTaxonomyOptions.length; i++) {
          options.push({label: this.filterTaxonomyOptions[i].name, code: this.filterTaxonomyOptions[i].id } );
        }

        this.options = options;
      } 
    }
  }

</script>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/ProductComparator.vue